import { useQuery } from '@apollo/client'
import { User, UserRole } from '__generated__/graphql'
import { GET_ME } from 'api/auth/me'
import { useEffect } from 'react'
import { globalLoaderVar, userVar } from 'shared/store/auth.store'

const MAIN_PROJECT_URL = 'https://xyro.io'

export const useAuthSession = () => {
  const { data, loading } = useQuery(GET_ME)

  useEffect(() => {
    const userData = data?.me || null

    // TODO: Add correct types to gql scheme
    if (
      !loading &&
      (!userData ||
        (userData?.role !== 'ADMIN' &&
          userData?.role !== ('WITHDRAWAL_OPERATOR' as UserRole)))
    ) {
      window.location = MAIN_PROJECT_URL as string & Location
      return
    }

    userVar(userData as User)
  }, [data?.me])

  useEffect(() => {
    globalLoaderVar(loading)
  }, [loading])
}
